import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  dateConversion,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { NavLink } from "react-router-dom";
import GRNPrint from "./GRNPrint";
import { getGrnList, editDeleteGrn } from "../../../actions/actions";
import grnService from "../../../services/grnService";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";

// ── STYLING (Matching Cylinder Inward Details) ─────────────────────────────

// Dialog Paper Style
const dialogPaperSx = {
  margin: "auto",
  width: "92vw",
  maxHeight: "85vh",
  boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
  overflow: "hidden",
  fontFamily: "'Inter', Arial, sans-serif",
  borderRadius: "8px",
};

// Dialog Header Style (Navy)
const dialogHeaderSx = {
  background: "#1C3A5E",
  padding: "14px 22px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const dialogHeaderTitleSx = {
  fontSize: "14px",
  fontWeight: 700,
  color: "#fff",
  letterSpacing: "0.5px",
  fontFamily: "'Inter', Arial, sans-serif",
};

// Dialog Content
const dialogContentSx = {
  padding: "20px 24px",
  background: "#F4F7FB",
  overflowY: "auto",
};

// Card Style (Info & Table)
const infoCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2.5,
};

// Card Sub-header (Light Navy)
const infoSubHeaderSx = {
  background: "#2A4F7A",
  padding: "9px 18px",
};

const infoSubHeaderTitleSx = {
  fontSize: "12px",
  fontWeight: 700,
  color: "#fff",
  fontFamily: "'Inter', Arial, sans-serif",
  letterSpacing: "0.4px",
};

// Grid Item Style (Bordered)
const infoItemSx = {
  borderRight: "1px solid #EDF2F7",
  borderBottom: "1px solid #EDF2F7",
  padding: "12px 16px",
};

// Typography for Labels
const infoLabelSx = {
  fontSize: "10px",
  fontWeight: 700,
  color: "#718096",
  textTransform: "uppercase",
  letterSpacing: "0.6px",
  mb: 0.5,
  fontFamily: "'Inter', Arial, sans-serif",
};

// Typography for Values
const infoValueSx = {
  fontSize: "14px",
  fontWeight: 600,
  color: "#2D3748",
  fontFamily: "'Inter', Arial, sans-serif",
};

// Table Header Style
const tableHeaderCellSx = {
  backgroundColor: "#1C3A5E !important",
  color: "#fff !important",
  fontFamily: "'Inter', Arial, sans-serif",
  fontWeight: 700,
  fontSize: "12px",
  padding: "10px 12px",
  whiteSpace: "nowrap",
  borderRight: "1px solid rgba(255,255,255,0.1)",
};

// Table Body Style
const tableBodyCellSx = {
  fontSize: "12px",
  fontFamily: "'Inter', Arial, sans-serif",
  color: "#2D3748",
  padding: "10px 12px",
  borderBottom: "1px solid #EDF2F7",
  borderRight: "1px solid #EDF2F7",
};

// Dialog Footer Button
const closeBtnSx = {
  background: "#E53E3E",
  color: "#fff",
  fontSize: "13px",
  fontWeight: 600,
  textTransform: "none",
  padding: "7px 20px",
  borderRadius: "8px",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#971f16" },
};

// ─────────────────────────────────────────────────────────────────────────────

const GRNList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.grn.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.grn.rows_per_page || 15);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  const fields = ["id", "dress_type", "cost"];
  const labels = ["Id", "dress_type", "cost"];
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [customermap, setCustomer] = useState({});
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);

  const [total_count, setTotalCount] = useState(null);
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);


  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await grnService.getGrnList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchKey);

    const params = {
      page: controller.page,
      size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
      searchKey: searchValue,
    };

    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  const deleteRecord = async (id) => {
    try {
      await grnService.editDeleteGrn({
        entry_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const [successMessage, setSuccessMessage] = useState(null);
  const respMsgState = useSelector((state) => state.grn.message);

  const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);
  useEffect(() => {
    if (respMsgState) {
      setSuccessMessage(respMsgState);
    }
  }, [respMsgState]);
  useEffect(() => {
  }, [shouldShowMsg, responseMessage,]);

  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;

  const safeParse = (jsonString) => {
    if (jsonString && typeof jsonString === "string") {
      try {
        return JSON.parse(jsonString) || [];
      } catch (e) {
        console.error("Error parsing JSON:", e);
        return [];
      }
    }
    return [];
  };

  const handleOpenDialog = (row) => {
    console.log("Opening dialog for row:", row);
    setSelectedRow(row);
    setSelectedCylinderDetails(safeParse(row.grn_details));
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            { name: "GRN / Material List" },
          ]}
        />

        <HeaderSection
          title="GRN / MATERIAL ENTRY LIST"
          addNewPath="/transactions/add-grn"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="GRN_List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />

        <Paper sx={{ width: '100%', }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("entry_no", sortBy, setSortBy, rows)}>
                    Entry No <span className={`${styles.sort_icon}`}> {sortBy === "entry_no" ? "▲" : "▼"} </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("entry_date", sortBy, setSortBy, rows)}>
                    Entry Date <span className={`${styles.sort_icon}`}> {sortBy === "entry_date" ? "▲" : "▼"} </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("invoice_no", sortBy, setSortBy, rows)}>
                    Invoice No <span className={`${styles.sort_icon}`}> {sortBy === "invoice_no" ? "▲" : "▼"} </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("challan_no", sortBy, setSortBy, rows)}>
                    Challan No <span className={`${styles.sort_icon}`}> {sortBy === "challan_no" ? "▲" : "▼"} </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("challan_date", sortBy, setSortBy, rows)}>
                    Challan Date <span className={`${styles.sort_icon}`}> {sortBy === "challan_date" ? "▲" : "▼"} </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("lr_no", sortBy, setSortBy, rows)}>
                    Transporter <span className={`${styles.sort_icon}`}> {sortBy === "lr_no" ? "▲" : "▼"} </span>
                  </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => HandleSort("transporter", sortBy, setSortBy, rows)}>
                    Vehicle No <span className={`${styles.sort_icon}`}> {sortBy === "transporter" ? "▲" : "▼"} </span>
                  </StyledTableCell>
                  {/* <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell> */}
                </StyledTableRow>
              </TableHead>

              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) &&
                  rows.map((row, index) => (
                    <StyledTableRow key={row.name} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        <Typography sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2", textDecoration: "underline", }} onClick={() => handleOpenDialog(row)}>
                          {row.entry_no || "N/A"}
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row?.entry_date)}</StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.invoice_no}</StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.challan_no}</StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row?.challan_date)}</StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.transporter}</StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.vehicle_no}</StyledTableCell>
                      {/* <StyledTableCell align="center">
                        <CustomePopover row={row} handleDelete={false} linkTo="/transactions/add-grn" handlePrint={false} showEdit={false} handleCancel={false} />
                      </StyledTableCell> */}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <CustomPagination page={controller.page} rowsPerPage={controller.rowsPerPage} totalCount={total_count || 0} onPageChange={(newPage) => handleChangePage(null, newPage)} />
        </Paper>

        {/* ── REDESIGNED GRN DETAILS DIALOG ── */}
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth={false} sx={{ "& .MuiDialog-paper": dialogPaperSx }}>
          {/* Dialog Header */}
          <Box sx={dialogHeaderSx}>
            <DescriptionIcon sx={{ fontSize: 18, color: "#fff" }} />
            <Typography sx={dialogHeaderTitleSx}>GRN DETAILS</Typography>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={dialogContentSx}>
            
            {/* ── General Information Card ── */}
            <Box sx={infoCardSx}>
              <Box sx={infoSubHeaderSx}>
                <Typography sx={infoSubHeaderTitleSx}>📋  General Information</Typography>
              </Box>
              
              <Grid container>
                {/* Row 1 */}
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>Entry No</Typography>
                  <Typography sx={infoValueSx}>{selectedRow?.entry_no || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>Supplier Name</Typography>
                  <Typography sx={infoValueSx}>{selectedRow?.supplier_name || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>Challan No</Typography>
                  <Typography sx={infoValueSx}>{selectedRow?.challan_no || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>LR No</Typography>
                  <Typography sx={infoValueSx}>{selectedRow?.lr_no || "—"}</Typography>
                </Grid>

                {/* Row 2 */}
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>Entry Date</Typography>
                  <Typography sx={infoValueSx}>{dateConversion(selectedRow?.entry_date)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>Plant</Typography>
                  <Typography sx={infoValueSx}>{selectedRow?.plant_name || "—"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>Challan Date</Typography>
                  <Typography sx={infoValueSx}>{dateConversion(selectedRow?.challan_date)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3} sx={infoItemSx}>
                  <Typography sx={infoLabelSx}>Vehicle No</Typography>
                  <Typography sx={infoValueSx}>{selectedRow?.vehicle_no || "—"}</Typography>
                </Grid>

                {/* Row 3 (Only one item) */}
                <Grid item xs={12} sm={6} md={3} sx={{ ...infoItemSx, borderRight: "none", borderBottom: "none" }}>
                  <Typography sx={infoLabelSx}>Transporter</Typography>
                  <Typography sx={infoValueSx}>{selectedRow?.transporter || "—"}</Typography>
                </Grid>
              </Grid>
            </Box>

            {/* ── Product Details Table ── */}
            <Box sx={infoCardSx}>
              {/* <Box sx={infoSubHeaderSx}>
                <Typography sx={infoSubHeaderTitleSx}>📦  Product Details</Typography>
              </Box> */}

              <TableContainer sx={{ maxHeight: "320px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {["Sr No", "Material Name","Qty (Kg)","Unit Rate"].map((header) => (
                        <StyledTableCell key={header} align="center" sx={tableHeaderCellSx}>
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          <StyledTableCell align="center" sx={tableBodyCellSx}>{index + 1}</StyledTableCell>
                          <StyledTableCell align="center" sx={tableBodyCellSx}>{row.matrial_code || "—"}</StyledTableCell>
                          {/* <StyledTableCell align="center" sx={tableBodyCellSx}>{row.uom || "—"}</StyledTableCell>
                          <StyledTableCell align="center" sx={tableBodyCellSx}>{row.challan_qty || 0}</StyledTableCell>
                          <StyledTableCell align="center" sx={tableBodyCellSx}>{row.recived_qty || 0}</StyledTableCell>
                          <StyledTableCell align="center" sx={tableBodyCellSx}>{row.short_qty || 0}</StyledTableCell> */}
                          <StyledTableCell align="center" sx={tableBodyCellSx}>{row.accepted_qty || 0}</StyledTableCell>
                           <StyledTableCell align="center" sx={tableBodyCellSx}>{row.unit_rate || 0}</StyledTableCell>
                          {/* <StyledTableCell align="center" sx={tableBodyCellSx}>{row.rejected_qty || 0}</StyledTableCell> */}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={8} align="center" sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}>
                          No product details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* Dialog Footer */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={handleCloseDialog} sx={closeBtnSx}>
              Close
            </Button>
          </Box>
        </Dialog>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.entry_id || null}
          displayName={deleteInfo?.entry_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default GRNList;